/* eslint-disable @typescript-eslint/no-explicit-any */

import type { ApiKey } from '@/types/api-key.type';

export const mapAPIKeyResponse = (data: Record<string, any>): ApiKey => {
  return {
    id: data.id,
    secret_name: data.secret_name,
    secret_value: data.secret_value,
    creator_user: {
      full_name: data.creator_user.full_name,
    },
    created_at: data.created_at,
  };
};

export const mapApiCreateApiResponse = (data: Record<string, any>): string => {
  const payload = data.data;
  return payload.secret_value;
};
